import api from 'api'

export type RequestedWorkerDecisionReasonId = 'accepted' | 'declined'

export type RequestedWorkerDecisionRequest = {
  agencyId: string
  workerRequestId: string
  workerId: number
  shiftId: number
  reasonId: RequestedWorkerDecisionReasonId
  reasonName: string
}

export const postRequestedWorkerDecision = async (
  request: RequestedWorkerDecisionRequest
): Promise<void> => {
  await api.post('/admin/dayforce/requested_worker_decision', request)
}
